import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

function Gallery() {

    return (

        <>

            <Header />


            {/*===== HERO AREA START =====*/}
            <div
                className="inner-hero"
                style={{ backgroundImage: "url(assets/img/bg/Ashok.jpg)" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 m-auto text-center">
                            <div className="inner-main-heading">
                                <h1>Gallery</h1>
                                <div className="breadcrumbs-pages">
                                    {/* <ul>
                                        <li>
                                            <a href="/Home">Home</a>
                                        </li>
                                        <li className="angle">
                                            <i className="fa-solid fa-angle-right" />
                                        </li>
                                        <li>Gallery</li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*===== HERO AREA START =====*/}





            <div className="team2 sp sec-bg2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="heading2">
                                {/* <span
                                    className="sub-title"
                                    data-aos="zoom-in-left"
                                    data-aos-duration={900}
                                >
                                    <img src="assets/img/icons/span3.svg" alt="" />
                                    OUR TEAM MEMBER{" "}
                                </span> */}
                                <h2 className="text-anime-style-3">Photos</h2>
                            </div>
                        </div>

                    </div>
                    <div className="row mt-30">
                        <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={200}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="gl2.jpg" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="gla1.jpg" alt="" />
                                    </div>
            
                                </div>
                               
                            </div>
                        </div>
                        <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={300}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="gal1.jpg" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="gl3.jpg" alt="" />
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                         <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={400}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="gl4.jpg" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="gl4.jpg" alt="" />
                                    </div>
                                </div>
                                
                            </div>
                        </div> 
                        <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={500}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="gl5.jpg" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="gl3.jpg" alt="" />
                                    </div>
                                   
                                </div>
                               
                            </div>
                        </div>
                         <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={500}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="gl3.jpg" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="gl3.jpg" alt="" />
                                    </div>
                                   
                                </div>
                               
                            </div>
                        </div>
                         <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={500}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="gl6.jpg" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="gl3.jpg" alt="" />
                                    </div>
                                   
                                </div>
                               
                            </div>
                        </div>
                         <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={500}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="gl7.jpg" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="gl3.jpg" alt="" />
                                    </div>
                                   
                                </div>
                               
                            </div>
                        </div>
                         <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={500}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="gl8.jpg" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="gl3.jpg" alt="" />
                                    </div>
                                   
                                </div>
                               
                            </div>
                        </div>
                    </div>


                    {/* <div className="row mt-30">
                        <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={200}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="gl7.jpg" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="gl8.jpg" alt="" />
                                    </div>
                                    <div className="social-icons">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-linkedin-in" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-x-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-youtube" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-instagram" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="team-content-area">
                                    <div className="heading2">
                                        <h4>
                                            <a href="#">Rodger Struck</a>
                                        </h4>
                                        <p className="mt-2">Social Media Specialist</p>
                                    </div>
                                    <div className="plue-icon">
                                        <a href="#">
                                            <i className="fa-solid fa-plus" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={300}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="assets/img/team/team2-image2.png" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="assets/img/shapes/team2-items-shape.png" alt="" />
                                    </div>
                                    <div className="social-icons">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-linkedin-in" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-x-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-youtube" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-instagram" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="team-content-area">
                                    <div className="heading2">
                                        <h4>
                                            <a href="#">Alex Buckmaster</a>
                                        </h4>
                                        <p className="mt-2">Marketing Officer</p>
                                    </div>
                                    <div className="plue-icon">
                                        <a href="#">
                                            <i className="fa-solid fa-plus" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={400}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="assets/img/team/team2-image3.png" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="assets/img/shapes/team2-items-shape.png" alt="" />
                                    </div>
                                    <div className="social-icons">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-linkedin-in" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-x-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-youtube" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-instagram" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="team-content-area">
                                    <div className="heading2">
                                        <h4>
                                            <a href="#">Sarah Joe</a>
                                        </h4>
                                        <p className="mt-2">Marketer</p>
                                    </div>
                                    <div className="plue-icon">
                                        <a href="#">
                                            <i className="fa-solid fa-plus" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="col-lg-3 col-md-6"
                            data-aos="fade-up"
                            data-aos-duration={900}
                            data-aos-delay={500}
                        >
                            <div className="team2-item mt-30">
                                <div className="team-image-area">
                                    <div className="image">
                                        <img src="assets/img/team/team2-image4.png" alt="" />
                                    </div>
                                    <div className="shape round-circle">
                                        <img src="assets/img/shapes/team2-items-shape.png" alt="" />
                                    </div>
                                    <div className="social-icons">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-linkedin-in" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-x-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-youtube" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fa-brands fa-instagram" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="team-content-area">
                                    <div className="heading2">
                                        <h4>
                                            <a href="#">Chris Glasser</a>
                                        </h4>
                                        <p className="mt-2">Marketer</p>
                                    </div>
                                    <div className="plue-icon">
                                        <a href="#">
                                            <i className="fa-solid fa-plus" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}


                </div>

            </div>

            {/* vedio  */}


  <div className="team2 sp sec-bg2">
  <div className="container">

    <div className="row">
      <div className="col-lg-6">
        <div className="heading2">
          {/* <span
            className="sub-title"
            data-aos="zoom-in-left"
            data-aos-duration={900}
          >
            <img src="assets/img/icons/span3.svg" alt="" />
            OUR TEAM MEMBER{" "}
          </span> */}
          <h2 className="text-anime-style-3">Videos</h2>
        </div>
      </div>
    </div>

    {/* Videos */}
    <div className="row mt-4">

      {/* Repeat this col for each video */}
      <div className="col-lg-4 col-md-6 mb-3">
        <video className="w-100" height="200" controls autoPlay loop muted style={{ objectFit: "cover" }}>
          <source src="ash1.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="col-lg-4 col-md-6 mb-3">
        <video className="w-100" height="200" controls autoPlay loop muted style={{ objectFit: "cover" }}>
          <source src="ash2.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="col-lg-4 col-md-6 mb-3">
        <video className="w-100" height="200" controls autoPlay loop muted style={{ objectFit: "cover" }}>
          <source src="ash3.mp4" type="video/mp4" />
        </video>
      </div>

      {/* second row */}
      {/* <div className="col-lg-4 col-md-6 mb-3">
        <video className="w-100" height="200" controls autoPlay loop muted style={{ objectFit: "cover" }}>
          <source src="/assets/video/service1-video.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="col-lg-4 col-md-6 mb-3">
        <video className="w-100" height="200" controls autoPlay loop muted style={{ objectFit: "cover" }}>
          <source src="/assets/video/service1-video.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="col-lg-4 col-md-6 mb-3">
        <video className="w-100" height="200" controls autoPlay loop muted style={{ objectFit: "cover" }}>
          <source src="/assets/video/service1-video.mp4" type="video/mp4" />
        </video>
      </div> */}

    </div>
  </div>
</div>




            <Footer />
        </>
    )
}

export default Gallery;